if (!customElements.get('variant-label')) {
  class VariantLabel extends HTMLElement {
    constructor() {
      super();
      this.variantLabels = this.querySelectorAll('.js-variant-label');
      this.initLazySection(); // run immediately
    }

    initLazySection() {
      if (!this.variantLabels) return;

      const product = this.closest('.product');
      const picker = product?.querySelector('variant-picker');

      const updateFromInput = () => {
        const variantInput = product?.querySelector('form[action*="/cart/add"] [name="id"]');
        if (variantInput && variantInput.value) {
          this.setVisibleVariantLabel(variantInput.value);
        }
      };

      // Initial run
      if (this.dataset.currentVariantId) {
        this.setVisibleVariantLabel(this.dataset.currentVariantId);
      }
      updateFromInput();

      // Watch the picker for DOM changes
      if (picker) {
        new MutationObserver(() => {
          updateFromInput();

          // Reattach change listeners to option inputs
          const optionInputs = picker.querySelectorAll('select[name^="options"], input[name^="options"]');
          optionInputs.forEach(input => {
            input.addEventListener('change', updateFromInput, { once: true });
          });
        }).observe(picker, { childList: true, subtree: true });
      }
    }

    setVisibleVariantLabel(variantId) {
      this.variantLabels.forEach((variantLabel) => {
        variantLabel.hidden = variantLabel.dataset.variantId.toString() !== variantId.toString();
      });
    }
  }

  customElements.define('variant-label', VariantLabel);
}
